import { type MinimumFeaturedListViewModel } from '@/wabunka-src/common/features/Featured';

import type { ComputedRef } from 'vue';

export const useFilteredFeaturedListQuery = (featuredList: Ref<MinimumFeaturedListViewModel>, destinationTagsQuery?: ComputedRef<string>, themeTagsQuery?: ComputedRef<string>) => {
  // カンマ区切りの文字列を配列に変換
  const destinationTags = computed<string[]>(() => (destinationTagsQuery?.value ? destinationTagsQuery.value.split(',') : []));
  const themeTags = computed<string[]>(() => (themeTagsQuery?.value ? themeTagsQuery.value.split(',') : []));

  /**
   * 渡されたitemが現在のフィルタ条件に一致するかどうかを判定します。
   * @param item - チェック対象の特集アイテム
   * @returns {boolean} - itemがフィルタ条件に一致すればtrue、そうでなければfalse
   */
  const matchesFilters = (item: MinimumFeaturedListViewModel[number]) => {
    const destinationTagsExist = destinationTags.value.length > 0;
    const themeTagsExist = themeTags.value.length > 0;

    // 1. フィルタタグが何も指定されていない場合は、全てを表示対象とする
    if (!destinationTagsExist && !themeTagsExist) {
      return true;
    }

    // 2. 取得データが持つタグと、クエリとして指定されたタグを比較
    // 指定されたdestinationタグのいずれかが、itemのdestinationTagsに含まれるか判定
    const hasMatchingDestination = destinationTagsExist && destinationTags.value.some((queryTag) => item.destinationTags?.some((itemTag) => itemTag === queryTag));

    // 指定されたthemeタグのいずれかが、itemのthemeTagsに含まれるか判定
    const hasMatchingTheme = themeTagsExist && themeTags.value.some((queryTag) => item.themeTags?.some((itemTag) => itemTag === queryTag));

    // destinationとthemeの両方が指定されている場合は、AND条件（両方に一致）となる
    if (destinationTagsExist && themeTagsExist) {
      return hasMatchingDestination && hasMatchingTheme;
    }

    // どちらか片方のタグだけが指定されている場合は、OR条件（指定された方に一致）
    return hasMatchingDestination || hasMatchingTheme;
  };

  // フィルタリングを適用したリスト
  const filteredList = computed<MinimumFeaturedListViewModel>(() => featuredList.value.filter(matchesFilters));

  const itineraryList = computed<MinimumFeaturedListViewModel>(() => filteredList.value.filter((item) => item.type === 'itinerary'));

  const destinationList = computed<MinimumFeaturedListViewModel>(() => filteredList.value.filter((item) => item.type === 'destination'));

  const themeList = computed<MinimumFeaturedListViewModel>(() => filteredList.value.filter((item) => item.type === 'theme'));

  return {
    itineraryList,
    destinationList,
    themeList,
  };
};
